import * as HTMLReactParser from '../lib';

const parse = HTMLReactParser.default;
Object.assign(parse, HTMLReactParser);

export default parse;
